import { gql } from "@outschool/ui-apollo";

export const LightActivityFragment = gql`
  fragment LightActivityFragment on Activity {
    uid
    user_uid
    slug_id
    title
    titleTranslated
    url
    path
    summary
    summaryTranslated
    is_ongoing_weekly
    details {
      photo
    }
    isClub
  }
`;
